import {
  USER_ROLE_ADMIN,
  USER_ROLE_NURSE,
} from '../../constants';
import BaseVoter from './base';

class TestVoter extends BaseVoter {
  /**
   * @param User user
   * @returns {boolean}
   */
  canView (user) {
    return this.isUser(user);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canAdd (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_NURSE]);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canEdit (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_NURSE]);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canAddResult (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_NURSE]);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canEditResult (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_NURSE]);
  }
}

export default new TestVoter();
